<div class="flex flex-column content">
  <div class="header">
    @if (isEditMode) {
      @if (hasPermission('CU003')) {
        <p class="col-12">{{ 'user-detail-component.editTitle' | transloco }}</p>
      }
      @if (!hasPermission('CU003')) {
        <p class="col-12">{{ 'user-detail-component.defaultTitle' | transloco }}</p>
      }
    }
    @if (!isEditMode) {
      <p class="col-12">{{ 'user-detail-component.title' | transloco }}</p>
    }
  </div>
  <p-scrollPanel [style]="{width: '100%', height: '75vh'}">
    <div class="basic-data">
      <p>{{ 'user-detail-component.basicDataTitle' | transloco }}</p>
      <form [formGroup]="form" (ngSubmit)="save()">
        <div class="flex align-items-center gap-2 mb-3 ml-3">
          <p-toggleSwitch formControlName="status"></p-toggleSwitch>
          <span>{{ form.get('status')?.value ? 'Ativo' : 'Inativo' }}</span>
        </div>
        <div class="flex flex-column md:flex-row sm:flex-row input-group">
          <div class="col-12 md:col-2 sm:col-2">
            <input type="text" mask="000.000.000-00" pInputText formControlName="cpf" (input)="verifyCpf()" placeholder="{{ 'user-detail-component.cpfInput' | transloco }}"/>
            @if (form.get('cpf')?.invalid && form.get('cpf')?.touched) {
              <div class="log">
                @if (form.get('cpf')?.errors?.['required']) {
                  <p>{{'user-detail-component.error.EmptyField' | transloco}}</p>
                }
                @if (form.get('cpf')?.errors?.['cpfLengthError']) {
                  <p>{{'user-detail-component.error.cpfLengthError' | transloco}}</p>
                }
                @if (form.get('cpf')?.errors?.['invalidDigits']) {
                  <p>{{'user-detail-component.error.invalidDigits' | transloco}}</p>
                }
                @if (form.get('cpf')?.errors?.['inputCpfLastCaracterError']) {
                  <p>{{'user-detail-component.error.inputCpfLastCaracterError' | transloco}}</p>
                }
              </div>
            }
          </div>
          <div class="col-12 md:col-5 sm:col-5">
            <input type="text" pInputText formControlName="name" placeholder="{{ 'user-detail-component.nameInput' | transloco }}"/>
            @if (form.get('name')?.invalid && form.get('name')?.touched) {
              <div class="log">
                @if (form.get('name')?.errors?.['required']) {
                  <p>{{'user-detail-component.error.EmptyField' | transloco}}</p>
                }
                @if (form.get('name')?.errors?.['invalidUserName']) {
                  <p>{{'user-detail-component.error.invalidUserName' | transloco}}</p>
                }
                @if (form.get('name')?.errors?.['maxLenghUserName']) {
                  <p>{{'user-detail-component.error.maxLenghUserName' | transloco}}</p>
                }
              </div>
            }
          </div>
          <div class="col-12 md:col-5 sm:col-5">
            <input type="text" pInputText formControlName="email" placeholder="{{ 'user-detail-component.emailInput' | transloco }}"/>
            @if (form.get('email')?.invalid && form.get('email')?.touched) {
              <div class="log">
                @if (form.get('email')?.errors?.['required']) {
                  <p>{{'user-detail-component.error.EmptyField' | transloco}}</p>
                }
                @if (form.get('email')?.errors?.['invalidEmailMask']) {
                  <p>{{'user-detail-component.error.invalidEmailMask' | transloco}}</p>
                }
              </div>
            }
          </div>
        </div>
        <p>{{ 'user-detail-component.permissionTitle' | transloco }}</p>
        @for (group of selectedGroups; track group; let i = $index) {
          <div class="flex flex-column input-group md:flex-row sm:flex-row">
            <div class="col-12 md:col-4 sm:col-4">
              <p-select [options]="groups" [disabled]="true" optionLabel="label" placeholder="{{ group.name }}"></p-select>
            </div>
            <div class="col-12 md:col-3 sm:col-3">
              <p-select [options]="profiles" [disabled]="true" optionLabel="label" placeholder="{{ group.accessLevelName }}"></p-select>
            </div>
            <div class="col-12 md:col sm:col">
              <p-button [disabled]="!hasPermission('CU003')" icon="pi pi-trash" (click)="removeGroup(i)"></p-button>
            </div>
          </div>
        }
        <div class="flex flex-column input-group md:flex-row sm:flex-row">
          <div class="col-12 md:col-4 sm:col-4">
            <p-select [options]="groups" optionLabel="label" formControlName="group" placeholder="{{ 'user-detail-component.groupInput' | transloco }}"></p-select>
            @if (form.get('group')?.invalid && form.get('group')?.touched) {
              <div class="log">
                @if (form.get('group')?.errors?.['required']) {
                  <p>{{'user-detail-component.error.EmptyField' | transloco}}</p>
                }
              </div>
            }
          </div>
          <div class="col-12 md:col-3 sm:col-3">
            <p-select [options]="profiles" optionLabel="label" formControlName="accessLevel" placeholder="{{ 'user-detail-component.accessLevelInput' | transloco }}"></p-select>
            @if (form.get('accessLevel')?.invalid && form.get('accessLevel')?.touched) {
              <div class="log">
                @if (form.get('accessLevel')?.errors?.['required']) {
                  <p>{{'user-detail-component.error.EmptyField' | transloco}}</p>
                }
              </div>
            }
          </div>
          <div class="col-12 md:col sm:col">
            <p-button [disabled]="hasPermission('CU003')" icon="pi pi-trash"></p-button>
          </div>
        </div>
        <div class="col-12 md:col-7 sm:col-7">
          @if (hasPermission('CU002')) {
            <p-button (click)="addGroup()" class="new-group-btn" size="small" severity="primary">{{ 'user-detail-component.newPermissionBtn' | transloco }}</p-button>
          }
        </div>
        <div class="flex flex-row justify-content-center md:justify-content-between sm:justify-content-between save-cancel-btn mb-4 mt-4">
          <p-button class="cancel-btn" label="{{ 'user-detail-component.backBtn' | transloco }}" (click)="back()"></p-button>
          <div>
            @if (hasPermission('CU002')) {
              <p-button class="cancel-btn" label="{{ 'user-detail-component.cancelBtn' | transloco }}" (click)="cancel()"></p-button>
            }
            @if (hasPermission('CU003')) {
              <p-button type="submit" label="{{ isEditMode ? ('user-detail-component.updateBtn' | transloco) : ('user-detail-component.saveBtn' | transloco) }}"></p-button>
            }
          </div>
        </div>
        <p-toast key="success" position="bottom-right" [baseZIndex]="100000" />
        <p-toast key="error" position="bottom-right" [baseZIndex]="100000" />
        <p-toast key="cancel" position="bottom-right" [baseZIndex]="100000">
          <ng-template let-messsage #headless let-closeFn="closeFn">
            <div class="flex flex-column toast">
              <div class="flex flex-row header gap-4">
                <h4>{{ messsage.summary }}</h4>
                <p-button (click)="closeFn($event)" size="small" icon="pi pi-times" />
              </div>
              <div class="flex flex-row content gap-3">
                <i class="pi pi-exclamation-triangle"></i>
                <p>{{ messsage.detail }}</p>
              </div>
              <div class="flex flex-row justify-content-end gap-4 pb-3 pr-3">
                <p-button (click)="closeFn($event)" variant="text">{{'user-detail-component.toast.stayOnPageBtn' | transloco}}</p-button>
                <p-button (click)="back()">{{'user-detail-component.toast.backToPreviousPage' | transloco}}</p-button>
              </div>
            </div>
          </ng-template>
        </p-toast>
      </form>
    </div>
  </p-scrollPanel>
</div>